import { defineComponent, ref, computed, watch, openBlock, createElementBlock, createElementVNode, createVNode, unref, withCtx, createCommentVNode, mergeProps } from "vue";
import { CdrButton, IconArrowLeft, IconArrowRight } from "@rei/cedar";
import ProductReviewsIndividualReview from "../ProductReviewsIndividualReview/ProductReviewsIndividualReview.mjs";
const _hoisted_1 = {
  class: "review-modal"
};
const _hoisted_2 = {
  key: 0,
  class: "review-modal__image-container"
};
const _hoisted_3 = {
  class: "review-modal__image-container--bg"
};
const _hoisted_4 = ["src"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsReviewModal",
  props: {
    reviews: {},
    photoIndex: {},
    reviewIndex: {}
  },
  emits: ["metricsClick", "individualReviewFeedbackClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const scrollContainer = ref(null);
    const reviewIndex = ref(props.reviewIndex);
    const imageIndex = ref(props.photoIndex);
    const currentReview = computed(() => {
      var _a;
      return (_a = props.reviews) == null ? void 0 : _a[reviewIndex.value];
    });
    const currentPhotos = computed(() => {
      var _a;
      return (_a = props.reviews) == null ? void 0 : _a[reviewIndex.value].photos;
    });
    const isFirstImage = () => reviewIndex.value === 0 && imageIndex.value === 0;
    const isLastImage = () => {
      var _a;
      return reviewIndex.value + 1 === ((_a = props.reviews) == null ? void 0 : _a.length) && imageIndex.value + 1 === props.reviews[props.reviews.length - 1].photos.length;
    };
    watch(() => currentReview, () => {
      var _a;
      (_a = scrollContainer.value) == null ? void 0 : _a.scrollTo({
        top: 0
      });
    });
    const onArrowClickRight = () => {
      var _a;
      emit("metricsClick", {
        linkName: "reviews_image scroll"
      });
      if (imageIndex.value + 1 < currentPhotos.value.length) {
        imageIndex.value += 1;
      } else if (reviewIndex.value + 1 < ((_a = props.reviews) == null ? void 0 : _a.length)) {
        imageIndex.value = 0;
        reviewIndex.value += 1;
      }
    };
    const onArrowClickLeft = () => {
      emit("metricsClick", {
        linkName: "reviews_image scroll"
      });
      if (imageIndex.value - 1 >= 0) {
        imageIndex.value -= 1;
      } else if (reviewIndex.value - 1 >= 0) {
        reviewIndex.value -= 1;
        imageIndex.value = props.reviews[reviewIndex.value].photos.length - 1;
      }
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", _hoisted_1, [((_a = currentPhotos.value) == null ? void 0 : _a.length) > 0 ? (openBlock(), createElementBlock("section", _hoisted_2, [createElementVNode("div", _hoisted_3, [createElementVNode("img", {
        src: (_b = currentPhotos.value[imageIndex.value]) == null ? void 0 : _b.sizes.normal.Url,
        alt: "first picture"
      }, null, 8, _hoisted_4)]), createVNode(unref(CdrButton), {
        class: "review-modal__img-button--prev",
        "icon-only": true,
        "with-background": true,
        disabled: isFirstImage(),
        onClick: _cache[0] || (_cache[0] = ($event) => onArrowClickLeft())
      }, {
        default: withCtx(() => [createVNode(unref(IconArrowLeft))]),
        _: 1
      }, 8, ["disabled"]), createVNode(unref(CdrButton), {
        class: "review-modal__img-button--next",
        "icon-only": true,
        "with-background": true,
        disabled: isLastImage(),
        onClick: _cache[1] || (_cache[1] = ($event) => onArrowClickRight())
      }, {
        default: withCtx(() => [createVNode(unref(IconArrowRight))]),
        _: 1
      }, 8, ["disabled"])])) : createCommentVNode("", true), createElementVNode("section", {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        class: "review-modal__review-container"
      }, [createVNode(ProductReviewsIndividualReview, mergeProps(currentReview.value, {
        "is-modal": true,
        onMetricsClick: _cache[2] || (_cache[2] = (data) => emit("metricsClick", data)),
        onIndividualReviewFeedbackClick: _cache[3] || (_cache[3] = (body) => emit("individualReviewFeedbackClick", body))
      }), null, 16)], 512)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsReviewModal2.mjs.map
